import React from "react";
import "./Home.css";
import Hero from "./Hero";
import MyComponent from "./MyComponent";
// import ExclusiveOffer from "./Exclusiveoffer";
import Partner from "./Partner";
import WhyChoose from "./WhyChoose";
import FlightDeal from "./FlightDeal";
import Choice from "./Choice";
import DiscoverSection from "./DiscoverSection";
import Comfort from "./Comfort";
import SectionOne from "./SectionOne";
import AboutSection from "./AboutSection";
import SectionFour from "./SectionFour";
import WhyUs from "./WhyUs";
import SectionTwo from "./SectionTwo";

function Home() {
  return (
    <div>
      <Hero />
      <AboutSection/>
     {/* <SectionOne/> */}
      {/* <MyComponent /> */}
      {/* <MyComponent /> */}
      <FlightDeal />
   
      
      {/* <ExclusiveOffer /> */}
      <SectionFour/>
      {/* <SectionTwo/> */}
      {/* <Choice/>  */}
      {/* <DiscoverSection/> */}
      <Comfort/>
      <DiscoverSection/>
      {/* <Partner /> */}
      {/* <WhyChoose /> */}

      <WhyUs/>
    </div>
  );
}

export default Home;
